import React from 'react'
import { ControlledInput } from "../../common/Input/Input";
import { ArrowLeft, Info } from 'react-feather';
import Select from "react-select";
import { toast } from "react-toastify";

const EditResource = (props) => {
    console.log(props.editResourceFields.nExpectedTAT)
    return (
        <div>
            <span style={{ cursor: "pointer" }} onClick={props.BackPage}>
                <ArrowLeft style={{ marginRight: "10px" }} />
            </span>
            <label>
                <b>Edit Resource</b>
            </label>
            <div className="row mt-2">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Resource Type <span className="required">*</span></label><br />
                    <Select
                        options={props.resourceTypeOption}
                        onChange={props.onResourceTypeChange}
                        value={props.selectedResourceType}
                        placeholder="Select Resource Type..."
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Resource SubType <span className="required">*</span></label><br />
                    <Select
                        options={props.resourceSubtype}
                        onChange={props.onResourceSubTypeChange}
                        value={props.selectedResourceSubType}
                        placeholder="Select Resource Subtype..."
                    />
                </div>

                {/* <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Resource Category <span className="required">*</span></label><br />
                    <Select
                        options={props.resourceCategory}
                        onChange={props.onResourceCategoryChange}
                        value={props.selectedResourceCategory}
                        placeholder="Select Resource Category..."
                    />
                </div> */}




            </div>

            <div className="row mt-3">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Resource ID <span className="required">*</span></label>
                    <span style={{ cursor: "pointer" }} title={"For Eg :- CASHFLOW"}>
                        <Info style={{ marginLeft: "10px", width: "15px" }} />
                    </span>
                    <br />
                    <ControlledInput
                        // name="rId"
                        name="sResourceID"
                        placeholder="Resource ID"
                        value={props.editResourceFields.sResourceID || ""}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        autoComplete="off"
                        disabled={true}
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Resource Display Name <span className="required">*</span></label><br />
                    <ControlledInput
                        // name="rResourceDisplayName"
                        name="sResourceName"
                        placeholder="Resource Display Name"
                        value={props.editResourceFields.sResourceName || ""}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        autoComplete="off"
                    />
                </div>

                {/* <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Is Financial Data Service</label><br />
                    <Select
                        className="w-50"
                        options={props.isFinancialDataService}
                        onChange={props.onIsFinancialDataServiceChange}
                        value={props.selectedIsFinancialDataService}
                    />
                </div> */}
            </div>

            {/* <div className="row ">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Is Service Provider</label><br />
                    <Select
                        className="w-50"
                        options={props.isServiceProvider}
                        onChange={props.onIsServiceProviderChange}
                        value={props.selectedIsServiceProvider}
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Is Unused Service</label><br />
                    <Select
                        className="w-50"
                        options={props.isUnusedService}
                        onChange={props.onIsUnusedServiceChange}
                        value={props.selectedIsUnusedService}
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Service Provider Only</label><br />
                    <Select
                        className="w-50"
                        options={props.serviceProviderOnly}
                        onChange={props.onServiceProviderOnlyChange}
                        value={props.selectedServiceProviderOnly}
                    />
                </div>
            </div> */}

            <div className="row mt-3">
                {/* <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Disable Service</label><br />
                    <Select
                        className="w-50"
                        options={props.disableService}
                        onChange={props.onDisableServiceChange}
                        value={props.selectedDisableService}
                    />
                </div> */}

                {/* <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Engagement Resource</label><br />
                    <Select
                        className="w-50"
                        options={props.engagementResource}
                        onChange={props.onEngagementResourceChange}
                        value={props.selectedEngagementResource}
                    />
                </div> */}

                <div className="col-4">
                    {/* <label style={{ marginBottom: "10px" }}>Expected TAT <span className="required">*</span></label><br /> */}
                    {/* <ControlledInput
                        className="w-50"
                        name="nExpectedTAT"
                        placeholder="Expected TAT"
                        value={(props.editResourceFields.nExpectedTAT === null || props.editResourceFields.nExpectedTAT === 0) ? "0" : props.editResourceFields.nExpectedTAT}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                            if (
                                !/^\d$/.test(e.key) &&
                                !allowedKeys.includes(e.key) &&
                                e.key !== "Tab"
                            ) {
                                e.preventDefault();
                            }
                        }}
                        autoComplete="off"
                    /> */}

                    {/* <ControlledInput
                        className="w-50"
                        name="nExpectedTAT"
                        placeholder="Expected TAT"
                        value={(props.editResourceFields.nExpectedTAT === null || props.editResourceFields.nExpectedTAT === 0) ? "0" : props.editResourceFields.nExpectedTAT}
                        // onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        onChange={({ target: { name, value } }) => {
                            const numericValue = Number(value);

                            // Allow only empty or digits 0-9
                            if (value === "" || (/^\d$/.test(value) && numericValue >= 0 && numericValue <= 99)) {
                                props.handleChange(name, value);
                            } else {
                                // Optional: add a toast or alert
                                toast("Please enter a number between 0 and 9", {
                                    type: toast.TYPE.ERROR,
                                    autoClose: 3000,
                                });
                            }
                        }}
                        onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                            if (
                                !/^\d$/.test(e.key) &&
                                !allowedKeys.includes(e.key) &&
                                e.key !== "Tab"
                            ) {
                                e.preventDefault();
                            }
                        }}
                        autoComplete="off"
                    /> */}
                </div>

            </div>

            <div className="row mt-3">
                <div className="col">
                    <button className='my-services-model-submit-btn' onClick={props.onSaveClick}> Save</button>
                </div>
            </div>


        </div>
    )
}

export default EditResource
